import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Loader = ({ type = "default" }) => {
  switch (type) {
    case "card":
      return <CardSkeleton />;
    case "profile":
      return <ProfileSkeleton />;
    case "feed":
      return <FeedSkeleton />;
    case "post":
      return <PostSkeleton />;
    default:
      return (
        <div className="flex justify-center items-center h-screen">
          <div className="flex flex-col items-center">
            <div className="flex flex-row gap-2 mb-4">
              <div className="w-4 h-4 rounded-full bg-blue-700 animate-bounce"></div>
              <div className="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:-.3s]"></div>
              <div className="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:-.5s]"></div>
            </div>
            <div className="text-gray-500">Loading...</div>
          </div>
        </div>
      );
  }
};

// Card skeleton for startup cards, venture cards, etc.
export const CardSkeleton = () => {
  return (
    <div className="border rounded-lg p-4 shadow-sm w-full">
      <div className="flex items-center mb-4">
        <Skeleton circle width={40} height={40} />
        <div className="ml-3 flex-1">
          <Skeleton width="80%" height={20} />
          <Skeleton width="50%" height={15} />
        </div>
      </div>
      <Skeleton count={3} height={15} className="mb-2" />
      <div className="mt-4">
        <Skeleton width="60%" height={30} />
      </div>
    </div>
  );
};

// Profile skeleton for profile pages
export const ProfileSkeleton = () => {
  return (
    <div className="w-full">
      <div className="h-40 bg-gray-200 rounded-t-lg">
        <Skeleton height={160} />
      </div>
      <div className="px-4 pb-4 relative">
        <div className="flex justify-between items-end -mt-16">
          <div className="w-32 h-32 rounded-full border-4 overflow-hidden">
            <Skeleton circle height="100%" />
          </div>
          <div>
            <Skeleton width={100} height={35} />
          </div>
        </div>
        <div className="mt-4">
          <Skeleton width="70%" height={24} />
          <Skeleton width="50%" height={20} className="mt-2" />
          <Skeleton width="90%" height={16} count={3} className="mt-4" />
        </div>
      </div>
    </div>
  );
};

// Feed skeleton for post feeds
export const FeedSkeleton = () => {
  return (
    <div className="w-full space-y-6">
      {Array(3).fill().map((_, index) => (
        <div key={index} className="border rounded-lg p-4 shadow-sm">
          <div className="flex items-center mb-4">
            <Skeleton circle width={50} height={50} />
            <div className="ml-3 flex-1">
              <Skeleton width="60%" height={20} />
              <Skeleton width="40%" height={15} />
            </div>
          </div>
          <Skeleton count={4} height={15} className="mb-2" />
          <div className="h-48 mt-4 mb-4">
            <Skeleton height="100%" />
          </div>
          <div className="flex justify-around mt-4">
            <Skeleton width={80} height={30} />
            <Skeleton width={80} height={30} />
            <Skeleton width={80} height={30} />
          </div>
        </div>
      ))}
    </div>
  );
};

// Post skeleton for individual posts
export const PostSkeleton = () => {
  return (
    <div className="border rounded-lg p-4 shadow-sm w-full">
      <div className="flex items-center mb-4">
        <Skeleton circle width={40} height={40} />
        <div className="ml-3 flex-1">
          <Skeleton width="70%" height={18} />
          <Skeleton width="40%" height={14} />
        </div>
      </div>
      <Skeleton count={3} height={15} className="mb-2" />
      <div className="mt-4 flex space-x-4">
        <Skeleton width={70} height={25} />
        <Skeleton width={70} height={25} />
      </div>
    </div>
  );
};

export default Loader;